import React, {FC} from 'react';
import {Glum} from '../../../puddleglum';
import {resolveOrderFaxNumber} from '../../../utils/orderFax';
import {Text, VStack} from 'components/ui/chakra';

type VoucherWithOrder = Glum.Models.Voucher & {
	price?: Glum.Models.Price | null;
};

const getOrderCollectionSummary = (voucher: VoucherWithOrder, faxNumber: string): string => {
	if (voucher.order_collection_method === 'upload') {
		return voucher.order_file_path ? 'Order uploaded' : 'Order upload missing';
	}

	if (voucher.order_collection_method === 'fax') {
		return `Patient was instructed to fax the order to ${faxNumber}`;
	}

	if (voucher.order_collection_method === 'contact_provider') {
		const providerName = voucher.ordering_provider_name || 'Ordering provider';
		const providerPhone = voucher.ordering_provider_phone || 'phone not provided';

		return `Contact ${providerName}: ${providerPhone}`;
	}

	return 'Order collection details were not provided';
};

interface VoucherOrderSummaryProps {
	voucher: VoucherWithOrder;
}

const VoucherOrderSummary: FC<VoucherOrderSummaryProps> = ({voucher}) => {
	if (!voucher.price?.is_order_required) return null;

	const faxNumber = resolveOrderFaxNumber(voucher.location?.fax, voucher.organization?.fax);

	return (
		<VStack align='start' spacing={0}>
			<Text color='orange.600' fontSize='xs' fontWeight='semibold'>
				Order required
			</Text>
			<Text color='gray.500' fontSize='xs'>
				{getOrderCollectionSummary(voucher, faxNumber)}
			</Text>
		</VStack>
	);
};

export default VoucherOrderSummary;
